import { langService } from '@/core';

export const hashedLithuaniaId = 'mn46ekl30291';
export const hashedLatviaId = 'z598embn0p6b';

export const languagesCountries = [
  {
    id: 'lt',
    icon: '@/components/icons/flags/lithuania.vue',
    get title() {
      return langService.trans('user.languages.lt');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'en',
    icon: '@/components/icons/flags/english.vue',
    get title() {
      return langService.trans('user.languages.en');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'lv',
    icon: '@/components/icons/flags/latvia.vue',
    get title() {
      return langService.trans('user.languages.lv');
    },
    get available() {
      return true;
    },
  },
];

export const pdfLanguagesCountries = [
  {
    id: 'lt',
    get title() {
      return langService.trans('user.languages.lt');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'en',
    get title() {
      return langService.trans('user.languages.en');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'lv',
    get title() {
      return langService.trans('user.languages.lv');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'fr',
    get title() {
      return langService.trans('user.languages.fr');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'de',
    get title() {
      return langService.trans('user.languages.de');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'ru',
    get title() {
      return langService.trans('user.languages.ru');
    },
    get available() {
      return true;
    },
  },
  {
    id: 'et',
    get title() {
      return langService.trans('user.languages.et');
    },
    get available() {
      return true;
    },
  },
];
